export const WORKSPACE_ROUTE_SAFETY = Object.freeze({
  PRESERVE: "PRESERVE",
  PRESERVE_WITH_RESET: "PRESERVE_WITH_RESET",
  REDIRECT_TO_PARENT: "REDIRECT_TO_PARENT",
  REDIRECT_TO_PROFILE: "REDIRECT_TO_PROFILE",
  BLOCK_IF_DIRTY: "BLOCK_IF_DIRTY",
});

const WORKSPACE_ROUTE_RULES = [
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/subscription\/checkout\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/vat-returns\/create-return\/?/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/tax-returns\/create-return\/?/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/epr-reporting\/add\/?/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/documents\/v2\/[^/]+\/(create|edit)\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/documents\/[^/]+\/create\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/documents\/exemption\/(add|create)\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/customers\/create\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/clients\/add-client\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/stores\/add\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/integrations\/add\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/transactions\/import\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/messages\/add\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/billing\/add-(payment|invoice)\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY, pattern: /^\/home\/add-news\/?$/ },

  {
    category: WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PARENT,
    pattern: /^\/messages\/[^/]+\/?$/,
    parentPath: "/messages",
  },
  {
    category: WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PARENT,
    pattern: /^\/upload-documents\/[^/]+(\/upload)?\/?$/,
    parentPath: "/messages",
  },
  {
    category: WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PARENT,
    pattern: /^\/help\/messenger\/[^/]+\/?$/,
    parentPath: "/help",
  },
  {
    category: WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PARENT,
    pattern: /^\/home\/news\/[^/]+\/?$/,
    parentPath: "/home/news",
  },
  {
    category: WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PARENT,
    pattern: /^\/settings\/country-specifics\/[^/]+\/products\/?$/,
    parentPath: "/settings",
  },

  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/profile\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/settings\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/notification-center\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/global-settings\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/personal-settings\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/business-settings\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/product-settings(\/[^/]+)?\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE, pattern: /^\/help\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/home\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/documents\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/e-documents\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/customers\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/transactions\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/vat-returns\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/tax-returns\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/epr-reporting\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/clients\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/reports\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/subscription\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/stores\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/integrations\/?$/ },
  { category: WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET, pattern: /^\/messages\/?$/ },
];

export const WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH = "/profile";

export function classifyRouteForWorkspaceSwitch(pathname) {
  const normalized = normalizePathname(pathname);
  if (!normalized) {
    return WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PROFILE;
  }

  for (const rule of WORKSPACE_ROUTE_RULES) {
    if (rule.pattern.test(normalized)) {
      return rule.category;
    }
  }

  return WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PROFILE;
}

export function getWorkspaceRouteSafetyDetails(pathname) {
  const normalized = normalizePathname(pathname);
  if (!normalized) {
    return {
      category: WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PROFILE,
      parentPath: null,
    };
  }

  for (const rule of WORKSPACE_ROUTE_RULES) {
    if (rule.pattern.test(normalized)) {
      return {
        category: rule.category,
        parentPath: rule.parentPath ?? null,
      };
    }
  }

  return {
    category: WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PROFILE,
    parentPath: null,
  };
}

export function resolveWorkspaceSwitchDestination({
  pathname,
  search = "",
  preserveCurrentRoute = false,
  navigation = null,
} = {}) {
  if (navigation?.path) {
    return buildPathWithQuery(navigation.path, navigation.query);
  }

  if (!preserveCurrentRoute) {
    return WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH;
  }

  const { category, parentPath } = getWorkspaceRouteSafetyDetails(pathname);

  switch (category) {
    case WORKSPACE_ROUTE_SAFETY.PRESERVE:
    case WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET:
      return `${normalizePathname(pathname) || WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH}${normalizeSearch(search)}`;
    case WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PARENT:
      return parentPath ?? WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH;
    case WORKSPACE_ROUTE_SAFETY.BLOCK_IF_DIRTY:
    case WORKSPACE_ROUTE_SAFETY.REDIRECT_TO_PROFILE:
    default:
      return WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH;
  }
}

export function isRouteSafeToPreserve(pathname) {
  const category = classifyRouteForWorkspaceSwitch(pathname);
  return (
    category === WORKSPACE_ROUTE_SAFETY.PRESERVE ||
    category === WORKSPACE_ROUTE_SAFETY.PRESERVE_WITH_RESET
  );
}

function normalizePathname(pathname) {
  const raw = String(pathname ?? "").trim();
  if (!raw) {
    return "";
  }
  const withoutQuery = raw.split("?")[0].split("#")[0];
  if (withoutQuery === "/") {
    return "/";
  }
  return withoutQuery.replace(/\/+$/, "") || "/";
}

function normalizeSearch(search) {
  const raw = String(search ?? "").trim();
  if (!raw) {
    return "";
  }
  return raw.startsWith("?") ? raw : `?${raw}`;
}

function buildPathWithQuery(path, query) {
  const basePath = normalizePathname(path) || WORKSPACE_SWITCH_FALLBACK_PROFILE_PATH;
  if (!query || typeof query !== "object") {
    return basePath;
  }
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value == null) {
      return;
    }
    const text = String(value).trim();
    if (text !== "") {
      params.set(key, text);
    }
  });
  const queryString = params.toString();
  return queryString ? `${basePath}?${queryString}` : basePath;
}
